import styled from 'styled-components';

const CORNER_VIEWBOX = '0 0 35.4751 34.689';
const CORNER_PATH =
  'M8.76205 0L0 8.76205V34.689L5.24046 31.1179V18.9266L4.59541 18.496V10.1293L10.0179 4.70689H18.3788L18.8971 5.24046H31.9487L35.4751 0H8.76205Z';

const ALL_POSITIONS = [
  'top-left',
  'top-right',
  'bottom-right',
  'bottom-left',
] as const;

const TOP_POSITIONS = ['top-left', 'top-right'] as const;

const CornerSvg = styled.svg`
  position: absolute;
  z-index: 1;
  width: var(--frame-corner-size, 35px);
  height: var(--frame-corner-size, 35px);

  &.top-left {
    top: 0;
    left: 0;
  }
  &.top-right {
    top: 0;
    right: 0;
    transform: rotate(90deg);
  }
  &.bottom-right {
    bottom: 0;
    right: 0;
    transform: rotate(180deg);
  }
  &.bottom-left {
    bottom: 0;
    left: 0;
    transform: rotate(270deg);
  }
`;

interface Props {
  topOnly?: boolean;
  color?: string;
}

export const FrameCorners = ({
  topOnly,
  color = 'var(--c-squads-secondary)',
}: Props) => {
  const positions = topOnly ? TOP_POSITIONS : ALL_POSITIONS;

  return (
    <>
      {positions.map(position => (
        <CornerSvg
          key={position}
          className={position}
          viewBox={CORNER_VIEWBOX}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={CORNER_PATH} fill={color} />
        </CornerSvg>
      ))}
    </>
  );
};
